/**
 * True when PostgREST says the RPC doesn't exist (its §-block isn't pasted
 * yet). Feature data layers turn this into their own "unavailable" error so
 * the UI hides the feature instead of showing an error.
 */
export function isMissingFunction(error: { code?: string; message?: string } | null): boolean {
  if (!error) return false;
  return error.code === "PGRST202" || /could not find the function/i.test(error.message ?? "");
}
